export default {
    getPost: state => (postId) => state.posts.find((questions) => questions.id == postId),
}
